import {Type, Dom, Tag, Browser, Loc, Event} from 'main.core';
import {EventEmitter} from 'main.core.events';
import {Lottie} from 'ui.lottie';
import {Popup} from 'main.popup';

import './reactions-select.css';
import './reactions-icon.css';

import e1 from '../animations/emoji_01.json';
import e2 from '../animations/emoji_02.json';
import e3 from '../animations/emoji_03.json';
import e4 from '../animations/emoji_04.json';
import e5 from '../animations/emoji_05.json';
import e6 from '../animations/emoji_06.json';
import e7 from '../animations/emoji_07.json';
import e8 from '../animations/emoji_08.json';
import e9 from '../animations/emoji_09.json';
import e10 from '../animations/emoji_10.json';
import e11 from '../animations/emoji_11.json';
import e12 from '../animations/emoji_12.json';
import e13 from '../animations/emoji_13.json';
import e14 from '../animations/emoji_14.json';
import e15 from '../animations/emoji_15.json';
import e16 from '../animations/emoji_16.json';
import e17 from '../animations/emoji_17.json';
import e18 from '../animations/emoji_18.json';
import e19 from '../animations/emoji_19.json';
import e20 from '../animations/emoji_20.json';
import e21 from '../animations/emoji_21.json';
import e22 from '../animations/emoji_22.json';
import e23 from '../animations/emoji_23.json';
import e24 from '../animations/emoji_24.json';
import e25 from '../animations/emoji_25.json';
import e26 from '../animations/emoji_26.json';
import e27 from '../animations/emoji_27.json';
import e28 from '../animations/emoji_28.json';
import e29 from '../animations/emoji_29.json';
import e30 from '../animations/emoji_30.json';
import e31 from '../animations/emoji_31.json';
import e32 from '../animations/emoji_32.json';
import e33 from '../animations/emoji_33.json';
import e34 from '../animations/emoji_34.json';
import e35 from '../animations/emoji_35.json';
import e36 from '../animations/emoji_36.json';
import e37 from '../animations/emoji_37.json';
import e38 from '../animations/emoji_38.json';
import e39 from '../animations/emoji_39.json';
import e40 from '../animations/emoji_40.json';
import e41 from '../animations/emoji_41.json';
import e42 from '../animations/emoji_42.json';
import e43 from '../animations/emoji_43.json';
import e44 from '../animations/emoji_44.json';
import e45 from '../animations/emoji_45.json';
import e46 from '../animations/emoji_46.json';
import e47 from '../animations/emoji_47.json';
import e48 from '../animations/emoji_48.json';
import e49 from '../animations/emoji_49.json';
import e50 from '../animations/emoji_50.json';
import e51 from '../animations/emoji_51.json';
import e52 from '../animations/emoji_52.json';
import e53 from '../animations/emoji_53.json';

export const reactionType = Object.freeze({
	like: 'like',
	redHeart: 'redHeart',
	fire: 'fire',
	okHand: 'okHand',
	kiss: 'kiss',
	smilingFaceWithHeartEyes: 'smilingFaceWithHeartEyes',
	smilingFaceWithHearts: 'smilingFaceWithHearts',
	faceWithTearsOfJoy: 'faceWithTearsOfJoy',
	laugh: 'laugh',
	slightlySmilingFace: 'slightlySmilingFace',
	wonder: 'wonder',
	facepalm: 'facepalm',
	star: 'star',
	neutralFace: 'neutralFace',
	cry: 'cry',
	loudlyCryingFace: 'loudlyCryingFace',
	angry: 'angry',
	winkingFace: 'winkingFace',
	slightlyFrowningFace: 'slightlyFrowningFace',
	faceWithStuckOutTongue: 'faceWithStuckOutTongue',
	faceWithStuckOutTongueAndWinkingEye: 'faceWithStuckOutTongueAndWinkingEye',
	smilingFaceWithSunglasses: 'smilingFaceWithSunglasses',
	partyingFace: 'partyingFace',
	confusedFace: 'confusedFace',
	flushedFace: 'flushedFace',
	thinkingFace: 'thinkingFace',
	smilingFaceWithHorns: 'smilingFaceWithHorns',
	faceWithThermometer: 'faceWithThermometer',
	pleadingFace: 'pleadingFace',
	relievedFace: 'relievedFace',
	clownFace: 'clownFace',
	handshake: 'handshake',
	clappingHands: 'clappingHands',
	raisedHand: 'raisedHand',
	foldedHands: 'foldedHands',
	signHorns: 'signHorns',
	loveYouGesture: 'loveYouGesture',
	flexedBiceps: 'flexedBiceps',
	hundredPoints: 'hundredPoints',
	sleepingSymbol: 'sleepingSymbol',
	crossMark: 'crossMark',
	whiteHeavyCheckMark: 'whiteHeavyCheckMark',
	eyes: 'eyes',
	poo: 'poo',
	dislike: 'dislike',
	questionMark: 'questionMark',
	exclamationMark: 'exclamationMark',
	lightBulb: 'lightBulb',
	bomb: 'bomb',
	palm: 'palm',
	lunch: 'lunch',
	cup2: 'cup2',
	cup: 'cup',
});

export const reactionLottieAnimations = Object.freeze({
	like: e28,
	laugh: e3,
	wonder: e6,
	cry: e8,
	angry: e17,
	facepalm: e20,
	kiss: e4,
	bomb: e23,
	redHeart: e25,
	faceWithThermometer: e19,
	okHand: e35,
	faceWithStuckOutTongueAndWinkingEye: e11,
	smilingFaceWithHearts: e31,
	relievedFace: e33,
	smilingFaceWithSunglasses: e12,
	faceWithTearsOfJoy: e5,
	neutralFace: e14,
	fire: e24,
	slightlySmilingFace: e1,
	winkingFace: e2,
	slightlyFrowningFace: e7,
	loudlyCryingFace: e9,
	faceWithStuckOutTongue: e10,
	confusedFace: e13,
	flushedFace: e15,
	thinkingFace: e16,
	smilingFaceWithHorns: e18,
	poo: e21,
	flexedBiceps: e22,
	clappingHands: e26,
	raisedHand: e27,
	dislike: e29,
	smilingFaceWithHeartEyes: e30,
	pleadingFace: e32,
	foldedHands: e34,
	signHorns: e36,
	loveYouGesture: e37,
	clownFace: e38,
	partyingFace: e39,
	questionMark: e40,
	exclamationMark: e41,
	lightBulb: e42,
	eyes: e43,
	crossMark: e44,
	whiteHeavyCheckMark: e45,
	sleepingSymbol: e46,
	hundredPoints: e47,
	handshake: e48,
	palm: e49,
	lunch: e50,
	star: e52,
	cup: e51,
	cup2: e53,
});

export const reactionCssClass = Object.freeze({
	like: 'reaction-icon_like',
	laugh: 'reaction-icon_laugh',
	wonder: 'reaction-icon_wonder',
	cry: 'reaction-icon_cry',
	angry: 'reaction-icon_angry',
	facepalm: 'reaction-icon_facepalm',
	kiss: 'reaction-icon_kiss',
	bomb: 'reaction-icon_bomb',
	redHeart: 'reaction-icon_redHeart',
	faceWithThermometer: 'reaction-icon_faceWithThermometer',
	okHand: 'reaction-icon_okHand',
	faceWithStuckOutTongueAndWinkingEye: 'reaction-icon_faceWithStuckOutTongueAndWinkingEye',
	smilingFaceWithHearts: 'reaction-icon_smilingFaceWithHearts',
	relievedFace: 'reaction-icon_relievedFace',
	smilingFaceWithSunglasses: 'reaction-icon_smilingFaceWithSunglasses',
	faceWithTearsOfJoy: 'reaction-icon_faceWithTearsOfJoy',
	neutralFace: 'reaction-icon_neutralFace',
	fire: 'reaction-icon_fire',
	slightlySmilingFace: 'reaction-icon_slightlySmilingFace',
	winkingFace: 'reaction-icon_winkingFace',
	slightlyFrowningFace: 'reaction-icon_slightlyFrowningFace',
	loudlyCryingFace: 'reaction-icon_loudlyCryingFace',
	faceWithStuckOutTongue: 'reaction-icon_faceWithStuckOutTongue',
	confusedFace: 'reaction-icon_confusedFace',
	flushedFace: 'reaction-icon_flushedFace',
	thinkingFace: 'reaction-icon_thinkingFace',
	smilingFaceWithHorns: 'reaction-icon_smilingFaceWithHorns',
	poo: 'reaction-icon_poo',
	flexedBiceps: 'reaction-icon_flexedBiceps',
	clappingHands: 'reaction-icon_clappingHands',
	raisedHand: 'reaction-icon_raisedHand',
	dislike: 'reaction-icon_dislike',
	smilingFaceWithHeartEyes: 'reaction-icon_smilingFaceWithHeartEyes',
	pleadingFace: 'reaction-icon_pleadingFace',
	foldedHands: 'reaction-icon_foldedHands',
	signHorns: 'reaction-icon_signHorns',
	loveYouGesture: 'reaction-icon_loveYouGesture',
	clownFace: 'reaction-icon_clownFace',
	partyingFace: 'reaction-icon_partyingFace',
	questionMark: 'reaction-icon_questionMark',
	exclamationMark: 'reaction-icon_exclamationMark',
	lightBulb: 'reaction-icon_lightBulb',
	eyes: 'reaction-icon_eyes',
	crossMark: 'reaction-icon_crossMark',
	whiteHeavyCheckMark: 'reaction-icon_whiteHeavyCheckMark',
	sleepingSymbol: 'reaction-icon_sleepingSymbol',
	hundredPoints: 'reaction-icon_hundredPoints',
	handshake: 'reaction-icon_handshake',
	palm: 'reaction-icon_palm',
	star: 'reaction-icon_star',
	lunch: 'reaction-icon_lunch',
	cup: 'reaction-icon_cup',
	cup2: 'reaction-icon_cup2',
});

export const reactionSelectEvents = Object.freeze({
	show: 'show',
	hide: 'hide',
	mouseenter: 'mouseenter',
	mouseleave: 'mouseleave',
	select: 'select',
	touchenter: 'touchenter',
	touchleave: 'touchleave',
	touchend: 'touchend',
	touchmove: 'touchmove',
});

export class ReactionsSelect extends EventEmitter
{
	#name;
	#containerClassname = '';
	#position;
	#baseClassname;
	#popupContentClassname;
	#reactionsPopup;
	#popupContent = null;
	#availableReactions;
	#hoveredElement;
	#touchMoveHandler = null;
	#touchEndHandler = null;
	#mouseEnterHandler = null;
	#mouseLeaveHandler = null;
	#isPopupTouched = false;
	#showClassname = 'reactions-popup-show';
	#hideClassname = 'reactions-popup-close';

	constructor(options = { name: 'ReactionsSelect', position: null })
	{
		super();
		this.setEventNamespace('UI:ReactionsSelect');

		this.#name = Type.isString(options.name) ? options.name : this.#generateName();
		this.#baseClassname = 'reaction-select';
		this.#popupContentClassname = `${this.#baseClassname}_container`;
		this.#availableReactions = Object.keys(reactionType);
		this.#reactionsPopup = null;
		this.#containerClassname = Type.isString(options.containerClassname) ? options.containerClassname : '';
		this.#position = this.#checkPositionOption(options.position) ? options.position : null;
		this.#hoveredElement = null;

		if (Browser.isMobile())
		{
			this.#touchMoveHandler = this.#handleTouchMove.bind(this);
			this.#touchEndHandler = this.#handleTouchEnd.bind(this);
		}
		else
		{
			this.#mouseEnterHandler = this.#handleMouseEnter.bind(this);
			this.#mouseLeaveHandler = this.#handleMouseLeave.bind(this);
			this.#touchMoveHandler = null;
			this.#touchEndHandler = null;
		}
	}

	static Events = reactionSelectEvents;

	static getLottieAnimation(reactionName)
	{
		if (!reactionName)
		{
			return reactionLottieAnimations;
		}

		return reactionLottieAnimations[reactionName] || null;
	}

	static getReactionCssClass(reactionName)
	{
		if (!reactionName)
		{
			return reactionCssClass;
		}

		return reactionCssClass[reactionName] || null;
	}

	show()
	{
		if (!this.#reactionsPopup)
		{
			this.#createReactionsPopup();
		}

		if (Browser.isMobile())
		{
			this.#disableScrollOnMobile();
			if (this.#touchMoveHandler)
			{
				Event.bind(window, 'touchmove', this.#touchMoveHandler);
			}
			if (this.#touchEndHandler)
			{
				Event.bind(window, 'touchend', this.#touchEndHandler);
			}
		}

		this.#reactionsPopup.show();
		this.emit(ReactionsSelect.Events.show);
	}

	hide()
	{
		if (this.#reactionsPopup)
		{
			if (this.#popupContent && this.#mouseLeaveHandler)
			{
				Event.unbind(this.#popupContent, 'mouseleave', this.#mouseLeaveHandler);
			}
			if (this.#popupContent && this.#mouseEnterHandler)
			{
				Event.unbind(this.#popupContent, 'mouseenter', this.#mouseEnterHandler);
			}
			if (this.#touchMoveHandler)
			{
				Event.unbind(window, 'touchmove', this.#touchMoveHandler);
			}
			if (this.#touchEndHandler)
			{
				Event.unbind(window, 'touchend', this.#touchEndHandler);
			}

			this.#reactionsPopup.close();
			this.#reactionsPopup = null;
			this.#popupContent = null;

			this.#enableScrollOnMobile();
		}

		this.emit(ReactionsSelect.Events.hide);
	}

	isShown()
	{
		return Boolean(this.#reactionsPopup && this.#reactionsPopup.isShown());
	}

	getName()
	{
		return this.#name;
	}

	#createReactionsPopup()
	{
		this.#reactionsPopup = new Popup({
			id: 'reactions-list-' + this.#name,
			content: this.#renderPopupContent(),
			...this.#getPopupPositionOptions(),
			noAllPaddings: true,
			borderRadius: '25px',
			animation: {
				showClassName: this.#showClassname,
				closeClassName: this.#hideClassname,
				closeAnimationType: 'animation',
			},
			cacheable: false,
			disableScroll: Browser.isMobile(),
			className: 'reaction-select-popup',
		});
	}

	#renderPopupContent()
	{
		this.#popupContent = Tag.render`
			<div class="${this.#getPopupContentClassname()}">
				${this.#renderReactionsList()}
			</div>
		`;

		if (!Browser.isMobile())
		{
			if (this.#mouseLeaveHandler)
			{
				Event.bind(this.#popupContent, 'mouseleave', this.#mouseLeaveHandler);
			}
			if (this.#mouseEnterHandler)
			{
				Event.bind(this.#popupContent, 'mouseenter', this.#mouseEnterHandler);
			}
		}

		return this.#popupContent;
	}

	#getPopupContentClassname()
	{
		const baseClassname = `${this.#popupContentClassname}`;
		const mobileDeviceModifier = `${Browser.isMobile() ? '--mobile' : ''}`;

		return [
			baseClassname,
			this.#containerClassname,
			mobileDeviceModifier,
		].join(' ');
	}

	#renderReactionsList()
	{
		const container = Tag.render`<div class="${this.#baseClassname}_list"></div>`;

		this.#availableReactions.forEach((reactionName) => {
			Dom.append(this.#renderReactionItem(reactionName), container);
		});

		return container;
	}

	#renderReactionItem(reactionName)
	{
		const className = `${this.#baseClassname}_reaction-icon-item`;
		const reactionTitle = Loc.getMessage(`REACTIONS_SELECT_${reactionName.toUpperCase()}`);
		const reactionIcon = this.#renderAnimatedReactionIcon(reactionName);
		const reactionHoverArea = this.#renderReactionItemHoverArea(reactionName);

		return Tag.render`
			<div
				class="${className}"
				data-reaction="${reactionName}"
				title="${reactionTitle}"
			>
				${reactionHoverArea}
				${reactionIcon}
			</div>
		`;
	}

	#renderAnimatedReactionIcon(reactionName)
	{
		const reactionIcon = Tag.render`<div class="${this.#baseClassname}_reaction-icon"></div>`;

		const animationData = reactionLottieAnimations[reactionName];

		if (animationData)
		{
			Lottie.loadAnimation({
				renderer: 'svg',
				container: reactionIcon,
				animationData,
			});
		}
		else
		{
			const iconClass = reactionCssClass[reactionName];

			if (iconClass)
			{
				Dom.addClass(reactionIcon, iconClass);
			}
		}

		return reactionIcon;
	}

	#renderReactionItemHoverArea(reactionName)
	{
		const className = `${this.#baseClassname}_reaction-hover-area`;
		const reactionHoverArea = Tag.render`<div class="${className}"></div>`;

		if (!Browser.isMobile())
		{
			Event.bind(reactionHoverArea, 'click', () => {
				this.emit(ReactionsSelect.Events.select, {
					reaction: reactionName,
				});
			});
		}

		return reactionHoverArea;
	}

	#getPopupPositionForBindElement()
	{
		const point = this.#position || { left: 0, top: 0 }; // clientX/clientY

		const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
		const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;

		// грубая оценка высоты/ширины попапа (многих реакций на несколько строк)
		const approxHeight = this.#popupContent
			? this.#popupContent.offsetHeight || 120
			: 120;
		const approxWidth = this.#popupContent
			? this.#popupContent.offsetWidth || 260
			: 260;

		let popupLeft = point.left;
		let popupTop;

		const offset = 8; // небольшой отступ от курсора

		// если от курсора вниз места меньше, чем примерно высота попапа — рисуем сверху
		if (viewportHeight - point.top < approxHeight + offset)
		{
			// слева снизу (курсор у нижнего левого угла попапа)
			popupTop = point.top - approxHeight - offset;
		}
		else
		{
			// слева сверху (курсор у верхнего левого угла попапа)
			popupTop = point.top + offset;
		}

		// защита по верхней границе
		if (popupTop < offset)
		{
			popupTop = offset;
		}

		// защита по правой границе
		if (popupLeft + approxWidth > viewportWidth - offset)
		{
			popupLeft = viewportWidth - approxWidth - offset;
		}
		if (popupLeft < offset)
		{
			popupLeft = offset;
		}

		const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0;

		return {
			left: popupLeft + scrollLeft,
			top: popupTop + scrollTop,
		};
	}

	#getPopupPositionOptions()
	{
		if (Type.isPlainObject(this.#position))
		{
			return {
				bindElement: this.#getPopupPositionForBindElement(),
			};
		}
		else if (Type.isDomNode(this.#position))
		{
			const pos = Dom.getPosition(this.#position);
			const left = (pos && pos.left) || 0;
			const top = (pos && pos.top) || 0;

			return {
				bindElement: { left, top },
			};
		}

		return {};
	}

	#handleTouchMove(e)
	{
		const reactionHoverArea = this.#getReactionHoverAreaFromTouch(e);
		const isCurrentTouchOnPopup = this.#checkIsPopupTouched(e);

		if (this.#isPopupTouched === false && isCurrentTouchOnPopup === true)
		{
			this.emit(ReactionsSelect.Events.touchenter);
		}
		else if (this.#isPopupTouched === true && isCurrentTouchOnPopup === false)
		{
			this.emit(ReactionsSelect.Events.touchleave);
		}

		this.#isPopupTouched = isCurrentTouchOnPopup;

		if (!reactionHoverArea)
		{
			if (this.#hoveredElement)
			{
				Dom.removeClass(this.#hoveredElement, '--hover');
				this.#hoveredElement = null;
			}
		}
		else if (this.#hoveredElement !== reactionHoverArea)
		{
			if (this.#hoveredElement)
			{
				Dom.removeClass(this.#hoveredElement, '--hover');
			}
			this.#hoveredElement = reactionHoverArea;
			Dom.addClass(this.#hoveredElement, '--hover');
		}

		this.emit(ReactionsSelect.Events.touchmove);
	}

	#handleTouchEnd(e)
	{
		const reactionHoverArea = this.#hoveredElement || this.#getReactionHoverAreaFromTouch(e);

		const reactionName = reactionHoverArea && reactionHoverArea.parentElement
			? reactionHoverArea.parentElement.getAttribute('data-reaction')
			: null;

		if (reactionName)
		{
			this.emit(ReactionsSelect.Events.select, {
				reaction: reactionName || null,
			});
		}
		this.emit(ReactionsSelect.Events.touchend);
	}

	#handleMouseLeave(e)
	{
		this.emit(ReactionsSelect.Events.mouseleave, e);
	}

	#handleMouseEnter(e)
	{
		this.emit(ReactionsSelect.Events.mouseenter, e);
	}

	#getReactionHoverAreaFromTouch(e)
	{
		const element = this.#getElementFromTouchEvent(e);

		return this.#isReactionHoverArea(element) ? element : null;
	}

	#isReactionHoverArea(element)
	{
		return Boolean(element && element.classList.contains('reaction-select_reaction-hover-area'));
	}

	#touchMoveScrollListener(e)
	{
		e.preventDefault();
	}

	#disableScrollOnMobile()
	{
		if (!Browser.isMobile())
		{
			return;
		}

		if (typeof app !== 'undefined' && app)
		{
			app.exec('disableTabScrolling');
		}

		this.emit('onPullDownDisable');
		Event.bind(window, 'touchmove', this.#touchMoveScrollListener, { passive: false });
	}

	#enableScrollOnMobile()
	{
		if (!Browser.isMobile())
		{
			return;
		}

		Event.unbind(window, 'touchmove', this.#touchMoveScrollListener);
		this.emit('onPullDownEnable');
	}

	#generateName()
	{
		const num = Math.round(Math.random() * 1000);

		return `ReactionsSelect${num}`;
	}

	#checkPositionOption(position)
	{
		if (position === undefined)
		{
			console.warn('UI.ReactionSelect: "position" parameter is required');
			return false;
		}
		else if (!Type.isDomNode(position) && !Type.isPlainObject(position))
		{
			console.warn('UI.ReactionSelect: "position" parameter must be an Object or an HTMLElement');
			return false;
		}
		else if (Type.isPlainObject(position) && !Type.isNumber(position.left))
		{
			console.warn('UI.ReactionSelect: position.left must be a number');
			return false;
		}
		else if (Type.isPlainObject(position) && !Type.isNumber(position.top))
		{
			console.warn('UI.ReactionSelect: position.top must be a number');
			return false;
		}

		return true;
	}

	#getElementFromTouchEvent(e)
	{
		if (!e || !e.touches || e.touches.length < 1)
		{
			return null;
		}
		const touch = e.touches.item(0);
		if (!touch)
		{
			return null;
		}
		const touchX = touch.pageX;
		const touchY = touch.pageY;

		return document.elementFromPoint(touchX, touchY);
	}

	#checkIsPopupTouched(e)
	{
		const element = this.#getElementFromTouchEvent(e);

		if (!element)
		{
			return false;
		}

		return Boolean(element.closest(`.${this.#popupContentClassname}`));
	}
}
